export default "__VITE_ASSET__Bv4d0DwD__"